import { http, makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('screens/cameras', {
  namespaced: true,

  resource () {
    return {
      id: null,
      name: mapped(null),
      connection_mode: mapped(null),
      ftp_client_directory: mapped(null)
    }
  },

  storeModule: {
    actions: {
      testClientFtp ({ getters }, { payload }) {
        return http.post(`${getters.uri('test-client-ftp')}`, payload)
      }
    }
  }
})
